<template>
    <form class="boxbranco buscainicial">
        <i class="fa fa-caret-square-o-up float-right text-muted pointer"
            aria-hidden="true"
            v-if="minimiza == true"
            @click="minimiza = !minimiza"
        ></i>
        <i class="fa fa-caret-square-o-down float-right text-muted pointer"
            aria-hidden="true"
            v-if="minimiza == false"
            @click="minimiza = !minimiza"
        ></i>

        <ul class="abas">
            <li :class="aba == 0 ? 'liativa' : ''" @click="aba = 0">por Unidade</li>
            <li :class="aba == 1 ? 'liativa' : ''" @click="aba = 1">por Tipo de Leito Livre</li>
        </ul>
        

        <fieldset class="bordas" v-show="aba == 0 && !minimiza">
            <!-- busca por unidade -->
            <div class="row mt-3">
                <div class="form-group col-sm-6">
                    <label for="unidade">Unidade</label>
                    <input v-if="!usuarioGestao" class="form-control" disabled :value="usuario.unidade" />
                    <multiselect
                        v-if="usuarioGestao"
                        :options="listaUnidades"
                        track-by="nomeCnes"
                        label="nomeCnes"
                        :searchable="true"
                        placeholder="Pesquise e selecione"
                        selectLabel="+"
                        deselectLabel="-" 
                        selectedLabel="selecionado"
                        v-model="unidade"
                        >

                        <span slot="noResult">Nenhum resultado encontrado.</span>
                    </multiselect>
                </div>

                <div class="form-group col-sm-3">
                    <label for="enfermarias">Enfermaria</label>
                    <select id="enfermarias" class="form-control" v-model="enfermaria">
                        <option value="" selected>Todas as Enfermarias</option>
                        <option v-for="(enfermaria, index) in listagemEnfermarias" :key="index" :value="enfermaria.nome">{{enfermaria.nome}}</option>
                    </select>
                </div>

                <div class="form-group col-sm-3">
                    <label for="enfermarias">Cód. Enfermaria</label>
                    <input class="form-control" v-mask="'####'" v-model="codEnfermaria">
                </div>
            </div>

        </fieldset>

        <fieldset class="bordas" v-if="aba == 1 && !minimiza">
            <!-- busca por tipo de leito -->
            <div class="row mt-3">
                <div class="form-group col-sm-6">
                    <label for="unidade">Tipo de Leito</label>
                    <select class="form-control" v-model="tipoleito">
                        <option value="" disabled>Selecione</option>
                        <option v-for="(tipo, index) in tiposLeito" :key="index" :value="tipo.id">{{tipo.nome}}</option>
                        <option value="todos">TODOS</option>
                    </select>
                </div>
            </div>
        </fieldset>

    </form>
</template>

<script>
import { websocket } from '../shared/mixins/websocket'

export default {
    mixins: [
        websocket
    ],
    mounted () {
        // Se a listaUnidades já estiver carregada, verifico de a Unidade da pessoa Logada está na relação de unidades
        if (this.listaUnidades.length > 0) this.verificaUnidadeLogada()
    },
    data () {
        return {
            minimiza: false,
            aba: 0,
            unidade: '',
            tipoleito: '',
        }
    },
    watch: {
        aba (value) {
            // Emito para o comp. pai para saber qual info carregar
            // ABA 0 = Busca por Unidade --- ABA 1 = Busca por Leito Livre
            this.$emit('aba', value)
        },
        listaUnidades (value) {
            // Verifico de a Unidade da pessoa Logada está na relação de unidades
            this.verificaUnidadeLogada()
        },
        unidade (value) {
            // Ao trocar o CNES selecionado, primeiro desconecto o WS do CNES anterior (caso haja)
            this.desconectaWebsocket()
            if (!value) this.$store.commit('leitos/setListagemMapaLeitos', null)
            if (value) {
                // Seto a Unidade Selecionada
                this.$store.commit('filtro/setUnidadeSelecionada', {cnes: this.unidade.cnes, nome: this.unidade.nome, tipo: this.unidade.tipo})
                // Limpo caso haja algum dado em Leito Transferência
                this.$store.commit('transferir/setLeitoTransferencia', null)
                // Limpo os restantes dos dados de filtro
                this.$store.commit('filtro/setEnfermariaSelecionada', '')
                this.$store.commit('filtro/setFiltroCodEnfermaria', '')

                // Pego a listagem de enfermarias do CNES selecionado e sua listagem de leitos
                this.$store.dispatch('filtro/pegaListagemEnfermarias', this.unidade.cnes)
                this.$store.dispatch('leitos/pegaListagemLeitos', this.unidade.cnes)
                .then(() => {
                    // Pego infos das últimas internações, exibidas na sidebar
                    this.$store.dispatch('informacoes/pegaUltimasInternacoes', this.unidade.cnes)
                    // Inicio o WS para o CNES selecionado
                    this.startWebsocket('principal', this.unidade.cnes, this.usuario.tokenAcesso)
                })
            }
            
        },
        tipoleito (value) {
            this.$store.commit('tipoleito/setTipoLeitoFiltradoStatus', null)
            value != 'todos' ? this.$store.dispatch('tipoleito/pegaMapaTipoLeito', value) : this.$store.dispatch('tipoleito/pegaMapaTipoLeito')
        },
    },
    computed: {
        usuario () {
            return this.$store.getters['sessao/getUsuario']
        },
        usuarioGestao () {
            return this.$store.getters['sessao/getUsuarioGestao']
        },
        wsAtivo () {
            return this.$store.getters['sessao/getWsAtivo']
        },
        listaUnidades () {
            return this.$store.getters['filtro/getListaUnidades']
        },
        tiposLeito () {
            return this.$store.getters['tipoleito/getTiposLeito']
        },
        listagemEnfermarias () {
            return this.$store.getters['filtro/getListagemEnfermarias']
        },
        enfermaria: {
            get () {
                return this.$store.getters['filtro/getEnfermariaSelecionada']
            },
            set (value) {
                this.$store.commit('filtro/setEnfermariaSelecionada', value)
            }
        },
        codEnfermaria: {
            get () {
                return this.$store.getters['filtro/getFiltroCodEnfermaria']
            },
            set (value) {
                this.$store.commit('filtro/setFiltroCodEnfermaria', value)
            }
        }
    },
    methods: {
        verificaUnidadeLogada () {
            // Verifico de a Unidade da pessoa Logada está na relação de unidades
            var obj = this.listaUnidades.find(option => option.cnes === this.usuario.cnes)

            if (obj !== null && obj !== undefined) {
                this.unidade = {
                    nomeCnes: obj.nomeCnes,
                    nome: obj.nome,
                    cnes: obj.cnes,
                    tipo: obj.tipo
                }
            }
        }
    },
}
</script>

<style>
.buscainicial {
    /* max-width: 980px; */
    width: 96%;
    margin: 0 auto;
}

.buscainicial fieldset {
    border-top: none;
}
</style>